import React from 'react'
import { TransProps } from '@lingui/react'
import {getColor} from 'components/utils'
import {LockClosedIcon} from '@heroicons/react/outline'
import { Trans } from '@lingui/macro';


// Type
export type typeInputCheckboxItem = {

    id: string,
    name: string,
    label: string,
    value?: string | number
    checked?: boolean
    required?: boolean
    disabled?: boolean
    itemDeleted?: boolean
}

export type typeInputCheckList = {
    variant?: string
    listLabel?: React.ReactElement<TransProps>
    listLabelClassName?: string
    fieldsetClassName?: string
    labelClassName?: string
    inputClassName?: string
    dataList: typeInputCheckboxItem[]
    setDataList:  React.Dispatch<React.SetStateAction<typeInputCheckboxItem[]>>
}


// Component
export const InputCheckList: React.FC<typeInputCheckList> = ({
    variant,
    listLabel,
    listLabelClassName,
    fieldsetClassName,
    labelClassName,
    inputClassName,
    dataList,
    setDataList,
}) => {

    const color = getColor(variant)

    const listLabelStyles = [`mb-1 block text-sm font-medium text-gray-700`, listLabelClassName].join(' ')
    const fieldsetStyles = [`border rounded-md px-5 py-2 overflow-y-auto`, fieldsetClassName].join(' ')
    const labelStyles = [`text-gray-700 flex-grow`, labelClassName].join(' ')
    const inputStyles = [` focus:ring-${color}-500 h-4 w-4 text-${color}-600 border-gray-300 rounded `, inputClassName].join(' ')

    const onCheckedHandler = (id: string) =>  {
        const newDataList = dataList.map(item => {
            if(item.id === id) {
                const newItem = item
                newItem.checked = !newItem.checked
                return newItem
            } else {
                return item
            }
        })
        setDataList(newDataList)
    }

    return(
        <>

            { listLabel
                ? <span className={listLabelStyles}>{listLabel}</span>
                : null
            }

            <fieldset className={fieldsetStyles}>

                {dataList.map((item, index) => {
                    return(
                        <div key={index} className="relative flex items-start py-2  hover:bg-blue-50 px-2 rounded-md">
                            <div className="flex w-full items-center gap-4">
                                {item.disabled
                                    ? <>
                                        <span className="block w-4"><LockClosedIcon className="h-4 w-4 text-gray-400"/></span>
                                        <span className="text-gray-400 cursor-not-allowed break-all">{item.label}</span>
                                    </>
                                    : <>
                                        <input
                                            id={item.id}
                                            name={item.name}
                                            type="checkbox"
                                            className={inputStyles}
                                            checked={item.checked}
                                            value={item.value}
                                            required={item.required}
                                            disabled={item.disabled}
                                            onChange={() => onCheckedHandler(item.id)}
                                        />
                                        <label htmlFor={item.id} className={labelStyles}>
                                            {item.label}{ item.itemDeleted? <span className="text-xs text-gray-400 font-normal"><Trans>(deleted)</Trans></span>: null}
                                        </label>
                                    </>
                                }

                            </div>
                        </div>
                    )
                })}

            </fieldset>
        </>
    )
}
